import React from "react";
import "./loadingSpinner.css";


export const LoadingSpinner = () => {
    return (
        <div className="fas fa-spinner"></div>
    )
}